import { ArrowUpRight } from 'lucide-react'

export default function ArrowBtn({ className = '' }: { className?: string }) {
  return (
    <div
      className={`w-8 h-8 rounded-full border border-white/[0.12] flex items-center justify-center text-white/30 group-hover:border-white/30 group-hover:text-white/60 transition-all shrink-0 ${className}`}
    >
      <ArrowUpRight className="w-4 h-4" />
    </div>
  )
}
